export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-Latin1-15ade3927fecfacfa515e1a048b7ac41.woff2";